import { Fragment } from "react";
import Footer from "../component/layout/footer";
import Header from "../component/layout/header";
import { Target, Eye, Users, Award, Globe, AlignJustify } from "lucide-react";

const AboutPage = () => {
    const aboutList = [
        {
            icon: <Users size={20} color="#ff4d88" />,
            title: "Who We Are",
            desc: "Kalakakshaaha is a trusted learning platform that brings together tutors, trainers, institutes, and students in one supportive ecosystem.",
        },
        {
            icon: <Award size={20} color="#4da6ff" />,
            title: "What We Offer",
            desc: "From arts and culture to academics and skill-based training, we provide diverse learning options guided by experienced educators.",
        },
        {
            icon: <Globe size={20} color="#33cc99" />,
            title: "Empowering Educators & Learners",
            desc: "We empower educators to share their expertise and help learners grow confidently in a safe, reliable, and engaging environment.",
        },
    ];

    return (
        <Fragment>
            <Header />

            <main className="kks-dark-wrapper" style={{ padding: "80px 0" }}>
                <div className="kks-contact-container">
                    <div className="row justify-content-center">
                        <div className="col-11 col-xxl-11" style={{ marginTop: "100px" }}>
                            <div className="kks-neon-card">
                                
                                {/* HEADER */}
                                <div className="kks-header-center">
                                    <span class="kks-subtitle">About Us</span>
                                   <h2 class="kks-title">Celebrating Culture, Creativity &amp; Artistic Learning</h2>  
                                   
                                   <p className="kks-desc" style={{ textAlign: "justify" }}>
VKAKSHAAHA EDUINSTITUTIONS LLP is established with a concept of introducing quality education to students. Education means -Academics and all kind of Art forms.
      </p>
      <p className="kks-desc" style={{ textAlign: "justify" }}>
As of now, we have started working on all Art forms and Languages like Dance, Music, Yoga, Martial arts, Foreign Languages etc., in the form of a website and the website name is
WWW.KALAKAKSHAAHA.COM
</p>  <p className="kks-desc" style={{ textAlign: "justify" }}>
 
This website works as a platform where Teachers who teach art forms and languages and students who wish to learn them can find each other.</p>
  <p className="kks-desc" style={{ textAlign: "justify" }}>
 
This website works as a search engine for students in which every teacher who registers in this website will have their own webpage so that they can introduce themselves and can edit and update their new and upcoming projects and curriculum using their login credentials which can be generated while registering in this website as a tutor. A student thus can search and find the tutor and can learn about the tutor, their experience, their qualification etc., and can decide whether to join or no.
 </p>
   <p className="kks-desc" style={{ textAlign: "justify" }}>
Our website will further in near future may expand as an e commerce platform where we wish to sell all products that’s related to the content that we promote in our website.
 
                                    </p>
                                </div>

                                <div className="kks-inner-grid">
                                    
                                    {/* IMAGE SECTION */}
                                    <div className="kks-image-box">
                                        <img
                                            src="assets/images/about/H1.png"
                                            alt="Learning Platform"
                                            className="main-img"
                                        />
                                    </div>

                                    {/* TEXT CONTENT */}
                                    <div className="kks-text-box">
                                        
                                        {/* MISSION */}
                                        <div className="kks-mini-item">
                                            <div className="kks-mini-icon">
                                                <Target size={16} color="#4da6ff" />
                                            </div>
                                            <div>
                                                <h6>Our Mission</h6>
                                                <p>
                                                    To remove barriers to quality education by creating opportunities 
                                                    for growth through accessible, inclusive, and flexible learning experiences.
                                                </p>
                                            </div>
                                        </div>

                                        {/* VISION */}
                                        <div className="kks-mini-item">
                                            <div className="kks-mini-icon">
                                                <Eye size={16} color="#4da6ff" />
                                            </div>
                                            <div>
                                                <h6>Our Vision</h6>
                                                <p>
                                                    To build an inclusive and trusted learning platform where quality education, 
                                                    creativity, and skill development are accessible to everyone, anytime and anywhere.
                                                </p>
                                            </div>
                                        </div>

                                        <hr
                                            style={{
                                                borderColor: "rgba(255,255,255,0.1)",
                                                margin: "30px 0",
                                            }}
                                        />

                                        {/* FEATURES */}
                                        {aboutList.map((item, index) => (
                                            <div key={index} className="kks-feature-row">
                                                <div className="kks-feature-icon-circle">
                                                    {item.icon}
                                                </div>
                                                <div className="kks-feature-info">
                                                    <h5>{item.title}</h5>
                                                    <p>{item.desc}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <Footer />

            {/* STYLES */}
            <style>{`
                .kks-contact-container {
                    width: 100%;
                    max-width: 1400px;
                    margin: 0 auto;
                    padding: 0 20px;
                }

                .kks-neon-card {
                    background: #000;
                    border: 1px solid #d4af37;
                    border-radius: 20px;
                    padding: 60px 50px;
                    box-shadow: 0 0 30px rgba(212, 175, 55, 0.15);
                }

                .kks-header-center {
                    text-align: center;
                    margin-bottom: 50px;
                }

                .kks-subtitle {
                    color: #ff4d88;
                    font-size: 22px;
                    font-weight: bold;
                    letter-spacing: 3px;
                }

                .kks-title {
                    color: #fff;
                    font-size: 40px;
                    margin-top: 15px;
                }

                .kks-desc {
                    color: #aaa;
                    font-size: 16px;
                    line-height: 1.8;
                    max-width: 900px;
                    margin: 20px auto 0;
                }

                .kks-inner-grid {
                    display: grid;
                    grid-template-columns: 1.1fr 0.9fr;
                    gap: 60px;
                    align-items: stretch;
                }

                .kks-image-box {
                    border-radius: 15px;
                    overflow: hidden;
                    border: 1px solid rgba(255,255,255,0.1);
                    height: 100%;              
                    display: flex;
                }

                .kks-image-box img {
                    width: 100%;
                    display: block;
                    object-fit: cover;         
                    display: block;
                }

                .kks-mini-item {
                    display: flex;
                    gap: 20px;
                    margin-bottom: 25px;
                }

                .kks-mini-icon {
                    min-width: 40px;
                    height: 40px;
                    background: rgba(77, 166, 255, 0.1);
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .kks-mini-item h6 {
                    color: #fff;
                    font-size: 18px;
                    margin-bottom: 5px;
                }

                .kks-mini-item p {
                    color: #999;
                    font-size: 14px;
                    line-height: 1.6;
                }

                .kks-feature-row {
                    display: flex;
                    gap: 20px;
                    margin-bottom: 25px;
                }

                .kks-feature-icon-circle {
                    min-width: 45px;
                    height: 45px;
                    border-radius: 50%;
                    border: 1px solid rgba(255,255,255,0.1);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .kks-feature-info h5 {
                    color: #fff;
                    font-size: 17px;
                }

                .kks-feature-info p {
                    color: #999;
                    font-size: 14px;
                }

                @media (max-width: 991px) {
                    .kks-inner-grid {
                        grid-template-columns: 1fr;
                    }
                    .kks-title {
                        font-size: 28px;
                    }
                    .kks-neon-card {
                        padding: 30px 20px;
                    }
                }
            `}</style>
        </Fragment>
    );
};

export default AboutPage;
